var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDealerInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_3322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47254 0 0 4.47293 0 10C0 15.5275 4.47293 20 10 20C15.5275 20 20 15.5271 20 10C20 4.47254 15.527 0 10 0ZM10 18.4375C5.33621 18.4375 1.5625 14.6635 1.5625 10C1.5625 5.33621 5.33652 1.5625 10 1.5625C14.6638 1.5625 18.4375 5.33652 18.4375 10C18.4375 14.6638 14.6634 18.4375 10 18.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.37225C9.56852 8.37225 9.21875 8.72202 9.21875 9.1535V14.1845C9.21875 14.616 9.56852 14.9657 10 14.9657C10.4315 14.9657 10.7812 14.6159 10.7812 14.1844V9.1535C10.7812 8.72202 10.4315 8.37225 10 8.37225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.41565C10.5825 7.41565 11.0547 6.94345 11.0547 6.36096C11.0547 5.77847 10.5825 5.30627 10 5.30627C9.41751 5.30627 8.94531 5.77847 8.94531 6.36096C8.94531 6.94345 9.41751 7.41565 10 7.41565Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_3322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDealerInfo);
export default __webpack_public_path__ + "static/media/icon-dealerInfo.1c46387fd0d0d3c093e8d7b343e7dd4e.svg";
export { ForwardRef as ReactComponent };